module.exports = __webpack_public_path__ + "templates/account-fields.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/customer-account/templates/account-fields.html
// module id = 6TRK
// module chunks = 1